import React from 'react';
import { SellerStepProps } from '@/types/seller-registration.types';
import { Checkbox } from '@/components/ui/checkbox';
import { ExternalLink } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export const SellerStepThree: React.FC<SellerStepProps> = ({
  formData,
  updateFormData,
  errors,
  clearError,
  t,
}) => {
  const { language } = useLanguage();
  
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl font-bold text-white mb-2">
          {t.steps.name} 3: {t.steps.terms}
        </h3>
        <p className="text-gray-300 text-sm">
          {language === 'fr' 
            ? "Veuillez lire et accepter nos Termes et Conditions avant de continuer."
            : "Please read and accept our Terms and Conditions before proceeding."}
        </p>
      </div>

      {/* Link to Full Terms */}
      <div className="bg-slate-700/50 border border-slate-600 rounded-lg p-6">
        <label className="block text-sm font-medium text-white mb-3">
          {language === 'fr' ? "Termes et Conditions" : "Terms and Conditions"} <span className="text-red-400">*</span>
        </label>
        <a
          href="/terms"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 px-4 py-3 bg-[#C9A86A] text-[#1D314D] rounded-lg hover:bg-[#D4B87A] transition-colors font-semibold"
        >
          {language === 'fr' ? "Voir les Termes et Conditions complets" : "View Full Terms & Conditions"}
          <ExternalLink size={18} />
        </a>
        <p className="text-xs text-gray-400 mt-2">
          {language === 'fr' 
            ? "Inclut l'Annexe B spécifique aux Vendeurs"
            : "Includes Annex B specific to Sellers"}
        </p>
      </div>

      {/* Terms Acceptance */}
      <div className="bg-slate-200 p-5 rounded-lg space-y-4">
        <label className="flex items-start gap-3 cursor-pointer">
          <Checkbox
            id="termsAccepted"
            checked={formData.termsAccepted}
            onCheckedChange={(checked) => {
              updateFormData({ termsAccepted: !!checked });
              clearError('termsAccepted');
            }}
            className="mt-1 border-gray-400"
          />
          <span className="text-[#1D314D] font-semibold leading-relaxed">
            {t.step3.termsAccept}
          </span>
        </label>
        {errors.termsAccepted && <p className="text-red-400 text-sm">{errors.termsAccepted}</p>}
      </div>
    </div>
  );
};
